import React from 'react';

import { connect } from 'react-redux';
import { Field, Formik } from 'formik';

import SelectField from '../../components/SelectField';
import ScreenWrapper from '../../components/ScreenWrapper';

import { PAGES } from '../../config/constants';
import contact_id_status, { BORROWER } from '../../constants/contact_id_status';

const SubmittingLoan = ({ setPrevPage, id_status, setFormValue }) => {
  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          marginBottom: 30,
        }}
      >
        Who is submitting the loan ?
      </h1>

      <ScreenWrapper step={2}>
        <Formik
          initialValues={{ id_status: id_status }}
          onSubmit={values => {
            setFormValue(values);
          }}
          validate={validate}
        >
          {({ handleSubmit }) => (
            <React.Fragment>
              <Field
                name="id_status"
                component={SelectField}
                options={contact_id_status}
                label="Submitting the Loan"
                cstmOnChange={async () => {
                  await Promise.resolve();
                  handleSubmit();
                }}
              />

              <div style={{ marginTop: 10 }}>
                <div style={{ float: 'left' }}>
                  <button
                    type="button"
                    className="cstm_btn cstm_btn-text"
                    onClick={setPrevPage}
                  >
                    Back
                  </button>
                </div>
                <div style={{ float: 'right' }}>
                  <button
                    type="button"
                    className="cstm_btn cstm_btn-blue"
                    onClick={handleSubmit}
                  >
                    Next
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const validate = values => {
  let errors = {};

  if (!values.id_status) {
    errors.id_status = 'Required';
  }

  return errors;
};

const mapState = state => {
  return {
    id_status: state.form.contacts.id_status,
  };
};

const mapDispatch = dispatch => {
  return {
    setPrevPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.TYPE_OF_LOAN,
      });
    },
    setFormValue: values => {
      dispatch({
        type: 'SET_FORM_CONTACTS',
        payload: values,
      });

      if (values.id_status === BORROWER.value) {
        dispatch({
          type: 'SET_PAGE',
          payload: PAGES.BORROWER_INFO,
        });
      } else {
        dispatch({
          type: 'SET_PAGE',
          payload: PAGES.BROKER_QUESTION,
        });
      }
    },
  };
};

export default connect(mapState, mapDispatch)(SubmittingLoan);



// WEBPACK FOOTER //
// ./src/Screens/SubmittingLoan/index.js